import React, { useEffect, useState } from "react";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import "../../css/AdminHeader.css";
import { auth, firestore } from "../../Common/firebase";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Layout from "../Layouts/Layout";

const CustomNavbar = ({ cartCount }) => {
  const navigate = useNavigate();
  const [userRole, setUserRole] = useState(localStorage?.getItem("userRole"));
  const [coursesDropdownOpen, setCoursesDropdownOpen] = useState(false);
  const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);
  const [howToStartDropdownOpen, setHowToStartDropdownOpen] = useState(false);
  const navbarStyle = {
    backgroundColor: "#70AD47",
  };

  useEffect(() => {
    const fetchUserRole = async () => {
      try {
        const currentUser = auth.currentUser;
        if (currentUser) {
          const userDoc = await firestore
            .collection("users")
            .doc(currentUser.uid)
            .get();
          if (userDoc.exists) {
            const userData = userDoc.data();
            setUserRole(userData.role);
            localStorage.setItem("userRole", userData.role);
          }
        }
      } catch (error) {
        console.error("Error fetching user role:", error.message);
      }
    };

    fetchUserRole();
  }, []);

  const handleLogout = async () => {
    const confirmationResult = await Swal.fire({
      title: "Are you sure you want to logout?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    });
    if (confirmationResult.isConfirmed) {
      try {
        localStorage.removeItem("userRole");
        setUserRole(null);
        await auth.signOut();
        navigate(`/login`);
      } catch (error) {
        console.error("Error during logout:", error.message);
      }
    }
  };

  const handleCoursesDropdownToggle = () => {
    setCoursesDropdownOpen(!coursesDropdownOpen);
  };

  const handleProfileDropdownToggle = () => {
    setProfileDropdownOpen(!profileDropdownOpen);
  };
  const handleHowToStartDropdownToggle = () => {
    setHowToStartDropdownOpen(!howToStartDropdownOpen);
  };

  const rightLinksStyle = {
    marginLeft: "auto",
    paddingRight: "5%",
  };

  // Course links data
  const courseLinks = [
    {
      name: "Getting Started",
      url: "https://insider.opscience.org/getting-started",
    },
    {
      name: "Course Navigation",
      url: "https://insider.opscience.org/course-navigation",
    },
    {
      name: "Course Evaluation Questions",
      url: "https://insider.opscience.org/course-evaluation-questions",
    },
    {
      name: "Evaluation Mechanics",
      url: "https://insider.opscience.org/evaluation-mechanics",
    },
    {
      name: "Course Status",
      url: "https://insider.opscience.org/course-status",
    },
    {
      name: "Certificate Download",
      url: "https://insider.opscience.org/certificate-download",
    },
  ];

  return (
    <>
      <Navbar collapseOnSelect expand="lg" style={navbarStyle} variant="dark">
        <Nav className="mr-auto ml-10px">
          <Nav.Link
            href="/Home"
            className="Home"
            style={{ marginLeft: "25px" }}
          >
            HOME
          </Nav.Link>
          <Nav.Link
            href={process.env.REACT_APP_WHY_OS}
            target="_blank"
            rel="noopener noreferrer"
            style={{ marginLeft: "25px" }}
          >
            WHY OS?
          </Nav.Link>
          <NavDropdown
            title="COURSES"
            id="collasible-nav-dropdown-courses"
            show={coursesDropdownOpen}
            onMouseEnter={handleCoursesDropdownToggle}
            onMouseLeave={handleCoursesDropdownToggle}
            style={{ marginLeft: "25px" }}
          >
            <NavDropdown.Item href="/CourseLibrary">
              Course Library
            </NavDropdown.Item>
            <NavDropdown.Item href="/UserCourseSelection">
              Course Selection
            </NavDropdown.Item>
            <NavDropdown.Item href="/UserMyCourse">My Courses</NavDropdown.Item>
          </NavDropdown>
        </Nav>
        <Navbar.Brand className="osi-heading">
          OPERATIONS SCIENCE INSTITUTE
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ml-auto" style={rightLinksStyle}>
            <NavDropdown
              title="HOW TO START"
              id="collasible-nav-dropdown-how-to-start"
              show={howToStartDropdownOpen}
              onMouseEnter={handleHowToStartDropdownToggle}
              onMouseLeave={handleHowToStartDropdownToggle}
              style={{ marginRight: "25px" }}
            >
              {courseLinks.map((course, index) => (
                <NavDropdown.Item
                  key={index}
                  href={course.url}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {course.name}
                </NavDropdown.Item>
              ))}
            </NavDropdown>
            <Nav.Link
              href="/cart"
              className="cart"
              style={{ marginRight: "25px" }}
            >
              CART ({cartCount})
            </Nav.Link>
            {userRole && (
              <NavDropdown
                title="PROFILE"
                id="collasible-nav-dropdown-profile"
                show={profileDropdownOpen}
                onMouseEnter={handleProfileDropdownToggle}
                onMouseLeave={handleProfileDropdownToggle}
                style={{ marginRight: "25px" }}
              >
                <NavDropdown.Item href="/EditProfile">
                  Edit Profile
                </NavDropdown.Item>
                <NavDropdown.Item href="#" onClick={handleLogout}>
                  Logout
                </NavDropdown.Item>
              </NavDropdown>
            )}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      <Layout />
    </>
  );
};

export default CustomNavbar;
